import { z } from 'zod';

export const OrganizationSecretItem = z.object({
  secretId: z.string(),
  secretDescription: z.string(),
  secretValuePresent: z.boolean(),
});

export type OrganizationSecretItem = z.infer<typeof OrganizationSecretItem>;

export const OrganizationSecretItems = z.object({
  secrets: z.array(OrganizationSecretItem),
});

export type OrganizationSecretItems = z.infer<typeof OrganizationSecretItems>;
